const $72a1ea3b1df807d3$var$winning = [
    [
        0,
        1,
        2
    ],
    [
        3,
        4,
        5
    ],
    [
        6,
        7,
        8
    ],
    [
        0,
        3,
        6
    ],
    [
        1,
        4,
        7
    ],
    [
        2,
        5,
        8
    ],
    [
        0,
        4,
        8
    ],
    [
        2,
        4,
        6
    ]
];
var $72a1ea3b1df807d3$export$2e2bcd8739ae039 = $72a1ea3b1df807d3$var$winning;


// DOM Elements
const $b63be9b0371e788c$var$headingEl = document.querySelector(".heading");
const $b63be9b0371e788c$var$currPlayerEl = document.querySelector(".current-player");
const $b63be9b0371e788c$var$boxesEl = document.querySelectorAll(".box");
const $b63be9b0371e788c$var$resetBtnEl = document.querySelector("button");
// Game Variables
const $b63be9b0371e788c$var$players = [
    "O",
    "X"
];
let $b63be9b0371e788c$var$currPlayer;
let $b63be9b0371e788c$var$gameGrid; // Virtual Game Grid
// Functions
function $b63be9b0371e788c$var$randomPlayer() {
    const newPlayer = Math.floor(Math.random() * 2);
    $b63be9b0371e788c$var$currPlayer = $b63be9b0371e788c$var$players[newPlayer];
}
function $b63be9b0371e788c$var$swapPlayer() {
    const newPlayer = $b63be9b0371e788c$var$currPlayer === $b63be9b0371e788c$var$players[0] ? $b63be9b0371e788c$var$players[1] : $b63be9b0371e788c$var$players[0];
    $b63be9b0371e788c$var$currPlayer = newPlayer;
}
function $b63be9b0371e788c$var$startGame() {
    // gameGrid insert 9 empty strings
    $b63be9b0371e788c$var$gameGrid = new Array(9).fill("");
    // hide reset button
    $b63be9b0371e788c$var$resetBtnEl.classList.remove("active");
    // generate random player
    $b63be9b0371e788c$var$randomPlayer();
    // show random player in current player
    $b63be9b0371e788c$var$currPlayerEl.textContent = $b63be9b0371e788c$var$currPlayer;
}
$b63be9b0371e788c$var$startGame();
function $b63be9b0371e788c$var$checkWinner() {
    (0, $72a1ea3b1df807d3$export$2e2bcd8739ae039).forEach((chance)=>{
        const [c1, c2, c3] = chance;
        if ($b63be9b0371e788c$var$gameGrid[c1] && $b63be9b0371e788c$var$gameGrid[c2] && $b63be9b0371e788c$var$gameGrid[c3] && $b63be9b0371e788c$var$gameGrid[c1] === $b63be9b0371e788c$var$gameGrid[c2] && $b63be9b0371e788c$var$gameGrid[c2] === $b63be9b0371e788c$var$gameGrid[c3]) {
            // show the win player in heading & current-player
            $b63be9b0371e788c$var$headingEl.textContent = `${$b63be9b0371e788c$var$gameGrid[c1]} Won!`;
            $b63be9b0371e788c$var$currPlayerEl.textContent = `${$b63be9b0371e788c$var$gameGrid[c1]} Won!`;
            // prevent clicking
            $b63be9b0371e788c$var$boxesEl.forEach((box)=>box.style.pointerEvents = "none");
            // show new game button
            $b63be9b0371e788c$var$resetBtnEl.classList.add("active");
            // add .green class
            $b63be9b0371e788c$var$boxesEl[c1].classList.add("green");
            $b63be9b0371e788c$var$boxesEl[c2].classList.add("green");
            $b63be9b0371e788c$var$boxesEl[c3].classList.add("green");
        }
    });
    const x = $b63be9b0371e788c$var$gameGrid.every((el)=>el !== "");
    if (x && !$b63be9b0371e788c$var$headingEl.textContent.includes("W")) {
        $b63be9b0371e788c$var$headingEl.textContent = "It's a Tie";
        $b63be9b0371e788c$var$resetBtnEl.classList.add("active");
    }
}
function $b63be9b0371e788c$var$handleClick(index) {
    // Only if the current box is empty
    if ($b63be9b0371e788c$var$gameGrid[index] === "") {
        // Update player in DOM and remove hover hand
        $b63be9b0371e788c$var$boxesEl[index].textContent = $b63be9b0371e788c$var$currPlayer;
        $b63be9b0371e788c$var$boxesEl[index].style.pointerEvents = "none";
        // Update virtual grid
        $b63be9b0371e788c$var$gameGrid[index] = $b63be9b0371e788c$var$currPlayer;
        // Swap player & Update on UI
        $b63be9b0371e788c$var$swapPlayer();
        $b63be9b0371e788c$var$currPlayerEl.textContent = $b63be9b0371e788c$var$currPlayer;
        // Check player winning status
        $b63be9b0371e788c$var$checkWinner();
    }
}
$b63be9b0371e788c$var$boxesEl.forEach((box, index)=>{
    box.addEventListener("click", ()=>{
        $b63be9b0371e788c$var$handleClick(index);
    });
});
// Reset Button
$b63be9b0371e788c$var$resetBtnEl.addEventListener("click", ()=>{
    $b63be9b0371e788c$var$startGame();
    $b63be9b0371e788c$var$headingEl.textContent = "Noughts & Crosses";
    $b63be9b0371e788c$var$boxesEl.forEach((box)=>{
        box.classList.remove("green");
        box.textContent = "";
        box.style.pointerEvents = "auto";
    });
});


//# sourceMappingURL=index.60179ba5.js.map
